
<div class="container">
	<div class="color-selector-container">
    <!--DropDown Button -->
	 <i class="fa-solid fa-a" (click)="showColorPallate()"></i> 
		<div>
		</div>
	</div>
	<div class="color-picker-container" *ngIf="colourPickerService.showColorPallateContainer"> 
		<div (click)="onSelect(codes)" class="color-picker" *ngFor="let codes of colorCodes" [ngStyle]="{backgroundColor:codes.colorCode}">
		</div>
	</div>
</div>



<ng-template cdk-portal #overlayTemplate="cdkPortal">
  
</ng-template>